import { Question } from "./QuestionTypes"

export const questions: Question[][] = [
	[
		{
			category: "art",
			challenge: "Which photo did I take during work?",
			answer: "Sea lions",
			content: "photography.jpg",
		},
		{
			category: "world",
			challenge: "Never have I ever, except...",
			choices: [
				{ option: "Been on a televised game show" },
				{ option: "Done a Tough Mudder", correct: true },
				{ option: "Travelled Europe" },
				{ option: "Quit smoking" },
			],
			reveal: "tough-mudder.jpg",
		},
		{
			category: "film",
			challenge: "What TV/film franchise am I the biggest fan of?",
			reveal: "enterprise-d.jpg",
			// content: "enterprise-d.jpg",
			choices: [
				{ option: "Battlestar" },
				{ option: "Stargate" },
				{ option: "Star Trek", correct: true },
				{ option: "Star Wars" },
			],
		},
		{
			category: "literature",
			challenge: "Where did I get my degree?",
			choices: [{ option: "BCIT" }, { option: "UBC" }, { option: "UNBC" }, { option: "N/A", correct: true }],
			reveal: "bcit.jpg",
		},
		{
			category: "literature",
			challenge: "What grade did I skip?",
			choices: [
				{ option: "Grade 2" },
				{ option: "Grade 5" },
				{ option: "Grade 9", correct: true },
				{ option: "Grade 11" },
			],
			reveal: "governors-medal.jpg",
		},
		{
			category: "local",
			challenge: "Which well-known person am I related to?",
			choices: [
				{ option: "Author H. G. Wells", correct: true },
				{ option: "Bill Nye the Science Guy" },
				{ option: "Former mayor of Smithers Jim Davidson", correct: true },
				{ option: "Haida artist Robert Davidson" },
				// { option: "NFL player Ben Davidson" },
			],
			reveal: "famous-family.jpg",
		},
		{
			category: "life",
			challenge: "What siblings do I have?",
			choices: [
				{ option: "One brother", correct: true },
				{ option: "One brother, one sister" },
				{ option: "One sister" },
				{ option: "Only child" },
			],
			reveal: "sean-family.jpg",
		},
		{
			category: "games",
			challenge: "What game do I play?",
			choices: [
				{ option: "Among Us" },
				{ option: "Call of Duty" },
				{ option: "Fortnite" },
				{ option: "StarCraft", correct: true },
			],
			reveal: "starcraft.jpg",
		},
		{
			category: "world",
			challenge: "Where is my wife from?",
			choices: [{ option: "India", correct: true }, { option: "Iran" }, { option: "Taiwan" }, { option: "Turkey" }],
			reveal: "mumbai.jpg",
		},
		{
			category: "tech",
			challenge: "What does my workstation look like?",
			choices: [
				{ option: "Dual screens and a minifridge", correct: true },
				{ option: "Laptop in a coffee shop" },
				{ option: "Plexiglass and water cooling" },
				{ option: "Mac Pro and a drafting table" },
			],
			reveal: "desk.jpg",
		},
		{
			category: "health",
			challenge: "What's my best lift?",
			choices: [
				{ option: "Bench press" },
				{ option: "Clean" },
				{ option: "Deadlift", correct: true },
				{ option: "Squat" },
			],
			reveal: "deadlift.mp4",
		},
		{
			category: "industry",
			challenge: "What was my job title before joining Emil Anderson?",
			choices: [
				{ option: "Data Analyst" },
				{ option: "IT Manager" },
				{ option: "IT/Environmental/Quality Manager and Quality Management Assistant", correct: true },
				{ option: "Support Specialist" },
			],
			reveal: "job-title.png",
		},
		{
			category: "life",
			challenge: "Where does my wife work?",
			choices: [
				{ option: "Canada's First Nations Radio (CFNR)" },
				{ option: "Coast Mountain College (CMTN)", correct: true },
				{ option: "Ministry of Transportation and Infrastructure (MOTI)" },
				{ option: "Rio Tinto/Alcan" },
			],
			reveal: "cmtn.jpg",
		},
		{
			category: "life",
			challenge: "Who have I known longest at EAG?",
			choices: [
				{ option: "Connor Lansdowne" },
				{ option: "Neal Corbett" },
				{ option: "Tyler Noble", correct: true },
				{ option: "Stephen Salter" },
			],
			reveal: "tyler-noble.jpg",
		},
		{
			category: "life",
			challenge: "Which amenity does my house have?",
			choices: [{ option: "Gym" }, { option: "Library" }, { option: "Pool" }, { option: "Theatre", correct: true }],
			reveal: "theatre.jpg",
		},
		{
			category: "health",
			challenge: "What's the most weight I've lost on a diet?",
			choices: [
				{ option: "30 lbs" },
				{ option: "50 lbs" },
				{ option: "75 lbs", correct: true },
				{ option: "100 lbs" },
			],
			reveal: "weightloss.jpg",
		},
		{
			category: "life",
			challenge: "What car do I drive?",
			choices: [
				{ option: "BMW M440i" },
				{ option: "Ford Fusion Hybrid", correct: true },
				{ option: "GMC Sierra Denali" },
				{ option: "Tesla Model 3" },
			],
			reveal: "caraccident.jpg",
		},
		{
			category: "world",
			challenge: "What was my last job prior to Nechako?",
			choices: [
				{ option: "Intern at Electronic Arts" },
				{ option: "IT Manager for Nisga'a Government", correct: true },
				{ option: "Financial Advisor, self-employed" },
				{ option: "Fresh out of college" },
			],
			reveal: "nlg.jpg",
		},
		{
			category: "tech",
			challenge: "What's my favourite sport?",
			choices: [
				{ option: "Cricket" },
				{ option: "Golf" },
				{ option: "Hockey" },
				// { option: "Monitor mount" },
				{ option: "Ultimate", correct: true },
			],
			reveal: "ultimate.jpg",
		},
		{
			category: "games",
			challenge: "What am I likely up to Thursday nights?",
			choices: [
				{ option: "Bar trivia", correct: true },
				{ option: "Chess" },
				{ option: "Dungeons and Dragons" },
				{ option: "Tutoring" },
			],
			reveal: "trivia.jpg",
		},
		// {
		// 	category: "tech",
		// 	challenge: "Favourite smartphone?",
		// 	choices: [
		// 		{ option: "Android" },
		// 		{ option: "Blackberry" },
		// 		{ option: "iPhone" },
		// 		{ option: "Undecided", correct: true },
		// 	],
		// 	reveal: "doesnt-matter.gif",
		// },
		// {
		// 	category: "philosophy",
		// 	challenge: "What is my greatest weakness?",
		// 	choices: [
		// 		{ option: "Adrenaline junkie" },
		// 		{ option: "Hyper-competitive tendencies" },
		// 		{ option: "Risk-aversion" },
		// 		{ option: "Social anxiety", correct: true },
		// 	],
		// },
		// {
		// 	category: "games",
		// 	challenge: "Which hobby have I never pursued?",
		// 	choices: [
		// 		{ option: "Chess" },
		// 		{ option: "Dungeons and Dragons" },
		// 		{ option: "Magic: The Gathering" },
		// 		{ option: "Photography" },
		// 		{ option: "Powerlifting" },
		// 		{ option: "Ultimate Frisbee" },
		// 	],
		// },
		// {category: "life", challenge: "What am I most afraid of?", choices: [{option: "Public speaking"}, {option: "Starting conversations"}]}
	],
]

// TODO audio support
// Identify YouTube channels eg Try Guys, Jeffrey Star, Sofia Nygard, Vsauce
// Russian Avengers ripoff movie scene
// What was Kirkegaard's philosophy
// What is a deepfake
// Whicho f these is a deepfake?
// Which scene (deepfake video game, etc.) is real life?
// How long for rabies symptoms
// Afghanistan language Pashto
// Pakistan language Urdu
// How many editions of Canadian currency are there?
// Where is Pondicherry
// Deadliest diseases in history
// New bridge Tuktouktuk
// Epic Rap Battles, identify character EG Gorbachev
// Russian plane company Sukhoi, MIG
// mortality rate, wars per country, diseseas
// Jewish folk party song with the side kicks
// $XIC $XMD $XIU
// How wide is the solar system?
// What year was the UN established?
// What is the most subscribed YouTube channel?
// What is Zoom?
// What year did Netflix start?
// How much memory is on a bluray disc?  (dual layer etc?)
// What is Dolby Atmos?
// What's the difference between sofa and chesterfield?
// What does NATO stand for?
// When/how did Stalin die?
// What is the DSM?
// Chemical equation?  H2SO4 + Cl = HSO4 + HCl kind of thing
// How many square kilometres of provincial park are there?
//  - Canadian question, national parks in Canada?  Jurisdiction differences?
// What kind of tree is this? (picture)
// What's the difference between red and black ants?  Species names, are they the same, etc?
// What celestial body has the largest mountain?  Earth/Venus/Mars/Moon?  Should be moon right?What criteria makes Pluto not a planet anymore?
// Daoism vs taoism?
// Korea what do the flag symbols represent (water fire earth wind)
// Scene from The Last Airbender
// Scene from Modern Family
// What industries does China lead?  Biggest oil and gas company?  Phone company?
// Something 5G.  "What is 5G"?
// Canadian companies.  Arc'teryx, Lululemon, Blackberry, Shopify
// What is Shopify?
// Physics: object is dropped from a height of 1 km in a vacuum tube on earth.  how long to hit bottom?
// How many people has Coronavirus infected?
// Who wrote Alice in Wonderland?
// What car logo is (mercury)
// Which fashion brand is founded/owned (careful on wodering) by a woman?  Versace, Dolce & Gabbana, Gucci, Burberry
// What is this logo?  Balenciaga?
// What is this logo?  Bentley, Alfa Romeo, Maserati, Mercury
// Identify this theme song?  Shows.  The Office.
// Who is this?  Carol Baskin
// Who is this?  Epstein
// Which of these is NOT a streaming service?  Hulu Spotify Netflix
// Who is the current UFC <weightclass> champion?
// What song is this?  lyrics "bright and early" "no expression" "filling up their glasses" sorrow.  Do the commercial.
// What percentage fo the internet is YouTube?  Netflix?
// What is the flower of BC?  Dogwood.
// Fendi logo
// How old is International Women's Day?
// How many Canadians have died at war?
// How many km of railroad are there in Canada?
// Beyonce's family names.  Blue Ivy?
// What is the difference between DSLR and mirrorless?
// Logo: Flickr
// Nursing: when did Canada or the WHO recommend masks?
// In 2010 Lady Gaga wore the meat dress
// What year did Blurred Lines come out
// PS I Love You movie clip.
// movie ideas
// akira
// american psycho
// cowboys and aliens
// dead poets society
// edge of tomorrow
// face off
// gattaco
// hot fuzz
// metaballs
// minority report
// obliviion
// rain man
// singing in the rain
// tangled
// the good the bad and the ugly
// thor ragnarok
// the wolf of wallstreet
// world war z
